import ErrorView from 'components/ErrorView';
import useCommon from 'hooks/useCommon';
import { PROJECT_TITLE } from 'libs/constants';
import getSubdomain from 'libs/subdomain';
import React, { FunctionComponent } from 'react';
import Header from '../../Header';

const CommonDeleted: FunctionComponent = () => {
  const { title } = useCommon();
  const { subdomain } = getSubdomain();

  const subject = title === PROJECT_TITLE ? subdomain : title;

  return (
    <div>
      <Header />
      <ErrorView
        title={`${subject} no longer has an active account with ${PROJECT_TITLE}.`}
        message=""
      />
    </div>
  );
};

export default CommonDeleted;
